module.exports = __webpack_public_path__ + "img/title_bg2.712079fc.png";